import { Navigate } from 'react-router';
import { Helmet } from 'react-helmet-async';

import { hasPermission } from 'src/utils/has-permissions';

import { useAuthContext } from 'src/auth/hooks';
import { AuthPermissions } from 'src/auth/permissions';

import { LoanAgreementListView } from 'src/sections/loan-agreement/view';

export default function LoanListPage() {
  const { user: authUser } = useAuthContext();

  return (
    <>
      <Helmet>
        <title>Loans</title>
      </Helmet>

      {hasPermission(
        authUser,
        'any',
        AuthPermissions.READ_LOAN_AGREEMENT,
        AuthPermissions.ADMIN_PERMISSION,
        AuthPermissions.SUPER_ADMIN_PERMISSION
      ) ? (
        <LoanAgreementListView />
      ) : (
        <Navigate to="/403" />
      )}
    </>
  );
}
